import qs from "query-string";
import { proxyQueryParams } from "./__internal__/QueryParamsProxy";
export function parseQueryParams(searchOrRawParams) {
    if (typeof searchOrRawParams === "string") {
        return parseQueryParams(qs.parse(searchOrRawParams));
    }
    return proxyQueryParams(searchOrRawParams !== null && searchOrRawParams !== void 0 ? searchOrRawParams : {});
}
